import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useEntityResolver } from 'hooks/use-entity-resolver'
import { EntityResolverLoading } from './entity-resolver-loading'
import { EntityResolverError } from './entity-resolver-error'

const EntityRedirect: React.FC = () => {
  const { entityName } = useParams<{ entityName: string }>()
  const history = useHistory()
  const [progress, setProgress] = useState<string>('Parsing entity name...')

  const {
    data: resolverResult,
    isLoading,
    error,
    isError,
  } = useEntityResolver(entityName)

  // Add progress tracking
  useEffect(() => {
    if (isLoading) {
      const progressSteps = [
        'Parsing entity name...',
        'Looking up terminal...',
        'Resolving entity details...',
        'Building route...',
      ]

      let step = 0
      const interval = setInterval(() => {
        if (step < progressSteps.length - 1) {
          step++
          setProgress(progressSteps[step])
        }
      }, 800)

      return () => clearInterval(interval)
    }
  }, [isLoading])

  // Redirect when resolution is complete
  useEffect(() => {
    if (resolverResult?.route) {
      history.replace(resolverResult.route)
    }
  }, [resolverResult, history, entityName])

  // Show loading state
  if (isLoading) {
    return (
      <EntityResolverLoading
        entityName={entityName || ''}
        progress={progress}
      />
    )
  }

  // Show error state
  if (isError || !resolverResult) {
    return (
      <EntityResolverError
        entityName={entityName || ''}
        error={(error as Error) || new Error('Unknown error')}
      />
    )
  }

  // This should not render if redirect worked
  return (
    <EntityResolverLoading entityName={entityName || ''} progress={progress} />
  )
}

export default EntityRedirect
